import React from 'react';
import ReservationReceipt from '../components/ReservationReceipt';

import '../styles/reservation.css';
import PrintButton from '../components/PrintButton';


const ReservationSheet = ({ reservationData }) => {

  
  if (!reservationData) {
    return <p>Aucune donnée de réservation disponible.</p>;
  }

  const handlePrint = () => {
    window.print();
  };


  return (
    
    <>
    <div id="reservation-sheet" className="reservation-sheet">
      {/* En-tête professionnelle */}
      <header className="reservation-header">
        <div className="header-left">
          <img src="./logo.png" alt="Logo agence" className="agency-logo" />
          <div className="agency-info">
            <h2>DJATER INTERNATIONAL SERVICES</h2>
            <p>Agence de voyages</p>
            <p>Tél: +225 27 21 54 46 59</p>
            <p>Email: djatervoyage@gmail.com</p>
            <p>Immeuble Baobab au 3e - Notre Dame Treichville (Abidjan)</p>
          </div>
        </div>
        <div className="header-right">
          <p><strong>CONFIRMATION DE RÉSERVATION</strong></p>
        </div>
      </header>

      {/* Contenu principal */}
      <main className="reservation-body">
        <h1 className="reservation-title">Reçu de réservation</h1>
        <ReservationReceipt data={reservationData} />
      </main>

      {/* Pied de page */}
      <footer className="reservation-footer">
        <p>
          Merci d’avoir réservé avec <strong>DJATER VOYAGE</strong>.
        </p>
        <p>
          Veuillez présenter cette confirmation lors de l’enregistrement.
        </p>
       
      </footer>
    </div>
    <div className="reservation-footer">
     <PrintButton 
      onPrint={handlePrint} />
      </div>
      <br /><br /><br />
    </>
  );
};

export default ReservationSheet;
